<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">

            <header>
                <h2 i18n>Unser Ticketsystem – Schnelle und unkomplizierte Kontaktaufnahme</h2>
            </header>

            <p i18n>Sie möchten unkompliziert Kontakt mit uns aufnehmen? Oder sie haben als Kunde eine neue Anforderung, ein technisches Problem oder benötigen Unterstützung? Kein
                Problem! Mit unserem
                benutzerfreundlichen
                Ticketsystem bieten wir Ihnen eine einfache Möglichkeit,
                Anfragen direkt an uns zu stellen.</p>

            <p i18n>Egal, ob es um eine technische Störung, eine Beratung oder eine allgemeine Frage geht – unser System gewährleistet,
                dass Ihr Anliegen effizient und strukturiert bearbeitet wird.</p>

        </div>
    </section>
</div>

<iframe id="JotFormIFrame-241746539253361" title="IT Service Ticket Form" allowtransparency="true"
    allow="geolocation; microphone; camera; fullscreen" src="https://form.jotform.com/241746539253361" frameborder="0"
    style="min-width:100%;max-width:100%;height:539px;border:none;" scrolling="no" i18n-title>
</iframe>
